var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcBlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "98px",
    height: "85px",
    viewBox: "0 0 98 85",
    style: {
      enableBackground: "new 0 0 98 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.lst0{fill:#003299;}\r\n\t.lst1{fill:#FFF315;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elements"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "lst0",
    d: "M0.4409,35h12.9683c0,0.5043,0,0.9366,0,1.6571c0,19.7406,15.8501,35.5908,35.5908,35.5908 s35.5908-15.8501,35.5908-35.5908c0-0.5043,0-0.9366,0-1.6571h12.9683v50H0.4409V35L0.4409,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lst0",
    d: "M16.5072,36.6571c0-17.7954,14.4092-32.2046,32.2046-32.2046s32.2046,14.4092,32.2046,32.2046 S66.5072,68.8617,48.7118,68.8617C31.2046,68.8617,16.5072,54.4524,16.5072,36.6571L16.5072,36.6571z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lst1",
    points: "52.098,9.7118 50.1527,11.1527 50.8732,13.3141 49,12.1614 47.0548,13.3141 47.7752,11.1527  45.83,9.7118 48.2795,9.7118 49,7.5504 49.7205,9.7118  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lst1",
    points: "52.098,61.4409 50.1527,62.8818 50.8732,65.0432 49,63.8184 47.0548,65.0432 47.7752,62.8818  45.83,61.4409 48.2795,61.4409 49,59.2795 49.7205,61.4409  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lst1",
    points: "64.8501,13.3141 62.9049,14.755 63.6254,16.9164 61.9683,15.4755 60.0231,16.9164 60.7435,14.755  58.8703,13.3141 61.0317,13.3141 61.9683,10.9366 62.6888,13.3141  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lst1",
    points: "74.4323,22.6801 72.5591,24.1931 73.2795,26.3545 71.3343,24.9135 69.389,26.3545 70.1095,24.1931  68.2363,22.6801 70.6138,22.6801 71.3343,20.5187 72.0548,22.6801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lst1",
    points: "77.8184,35.7205 75.8732,37.1614 76.6657,39.3228 74.7205,37.8818 72.7752,39.3228 73.4957,37.1614  71.5504,35.7205 74,35.7205 74.7205,33.5591 75.4409,35.7205  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lst1",
    points: "74.4323,48.6888 72.5591,49.9135 73.2795,52.2911 71.3343,50.8501 69.389,52.2911 70.1095,49.9135  68.2363,48.6888 70.6138,48.6888 71.3343,46.3112 72.0548,48.6888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lst1",
    points: "64.8501,58.0548 62.9049,59.4957 63.6254,61.6571 61.9683,60.2161 60.0231,61.6571 60.7435,59.4957  58.8703,58.0548 61.0317,58.0548 61.9683,55.8934 62.6888,58.0548  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lst1",
    points: "39.1297,58.0548 37.1844,59.4957 37.9049,61.6571 35.9597,60.2161 34.0865,61.6571 34.8069,59.4957  32.8617,58.0548 35.2392,58.0548 35.9597,55.8934 36.6801,58.0548  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lst1",
    points: "26.1614,35.7205 24.2161,37.1614 24.9366,39.3228 22.9914,37.8818 21.1182,39.3228 21.8386,37.1614  20.1095,35.7205 22.2709,35.7205 22.9914,33.5591 23.7118,35.7205  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lst1",
    points: "39.1297,13.3141 37.1844,14.755 37.9049,16.9164 35.9597,15.4755 34.0865,16.9164 34.8069,14.755  32.8617,13.3141 35.2392,13.3141 35.9597,10.9366 36.6801,13.3141  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lst1",
    points: "29.4755,22.6801 27.8184,24.1931 28.5389,26.3545 26.5937,24.9135 24.7205,26.3545 25.4409,24.1931  23.4957,22.6801 25.8732,22.6801 26.5937,20.5187 27.3141,22.6801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lst1",
    points: "29.4755,48.6888 27.8184,49.9135 28.5389,52.2911 26.5937,50.8501 24.7205,52.2911 25.4409,49.9135  23.4957,48.6888 25.8732,48.6888 26.5937,46.3112 27.3141,48.6888  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "lst1",
    d: "M29.4755,32.3343h3.8184c1.9452-7.7089,8.8617-13.2565,17.2911-13.2565c4.8271,0,9.366,1.9452,12.536,5.2594 l-1.2248,3.098c-2.6657-3.098-6.7003-5.2594-11.3112-5.2594c-6.7003,0-12.2478,4.3228-14.1931,10.3746h23.3429l-1.2248,2.8818 H35.6715c0,0.5043,0,0.9366,0,1.4409c0,0.5043,0,0.9366,0,1.4409h21.3977l-1.2248,2.8818H36.1037 c1.9452,5.9798,7.4207,10.3746,14.1931,10.3746c4.5389,0,8.6455-2.1614,11.3112-5.2594v4.1066 c-3.098,2.6657-6.9885,4.1066-11.3112,4.1066c-8.1412,0-15.1297-5.7637-17.2911-13.2565h-5.0432l1.2248-2.8818h3.3862 c0-0.5043,0-0.9366,0-1.4409c0-0.5043,0-0.9366,0-1.4409h-4.5389L29.4755,32.3343L29.4755,32.3343z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcBlogo);
export default __webpack_public_path__ + "static/media/ECBlogo.a57399528520406c4e8be3c09758d817.svg";
export { ForwardRef as ReactComponent };